import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getUser } from 'api/users';
import Cookies from 'js-cookie';
import { cookies } from 'api/_defaults/cookies';

export default function WelcomeMessage() {

    const userId = Cookies.get(cookies.user);

    const { data: user } = useQuery({
        queryKey: ['user', userId],
        queryFn: async () => await getUser({ id: userId }),
        enabled: !!userId,
    });

    const { firstname } = user || {};

    const getGreeting = () => {
        const hour = new Date().getHours();

        if (hour >= 5 && hour < 12) {
            return 'Buongiorno';
        } else if (hour >= 12 && hour < 18) {
            return 'Buon pomeriggio';
        } else if (hour >= 18 && hour < 22) {
            return 'Buonasera';
        } else {
            return 'Buonanotte';
        }
        
    };

    let greting = getGreeting();

    return (
        <div className='mb-8'>
            <h1 className='text-3xl md:text-4xl font-semibold text-black/90'>
                {[greting, firstname].filter(Boolean).join(', ')}!
            </h1>
        </div>
    );
}
